// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

import apiClient from '../config/api';
import { API_ENDPOINTS } from '../config/api';

const BASE = API_ENDPOINTS.KNOWLEDGE;

export async function fetchKnowledgeConfig() {
  const { data } = await apiClient.get(`${BASE}/config`);
  return data;
}

export async function listKnowledgeItems(params = {}) {
  const { data } = await apiClient.get(`${BASE}/items`, { params });
  return data;
}

export async function getKnowledgeItem(id, includeTechnical = false, options = {}) {
  const params = { include_technical: includeTechnical };
  if (options.include_archived) {
    params.include_archived = true;
  }
  const { data } = await apiClient.get(`${BASE}/items/${id}`, { params });
  return data;
}

export async function createKnowledgeItem(payload) {
  const { data } = await apiClient.post(`${BASE}/items`, payload);
  return data;
}

/**
 * Ollama: suggest title, slug, summary, cleaned content from pasted document text.
 */
export async function prepareKnowledgeDocument(payload) {
  const { data } = await apiClient.post(`${BASE}/ai/prepare-document`, payload, {
    timeout: 300000,
  });
  return data;
}

/**
 * Multipart upload: server extracts text from .docx / .pdf (field name: file).
 */
export async function extractKnowledgeImportText(formData) {
  const { data } = await apiClient.post(`${BASE}/import/extract-text`, formData, {
    timeout: 120000,
  });
  return data;
}

export async function addKnowledgeVersion(itemId, payload) {
  const { data } = await apiClient.post(`${BASE}/items/${itemId}/versions`, payload);
  return data;
}

export async function publishKnowledgeVersion(itemId, versionId) {
  const { data } = await apiClient.post(`${BASE}/items/${itemId}/publish/${versionId}`);
  return data;
}

export async function archiveKnowledgeItem(itemId) {
  const { data } = await apiClient.post(`${BASE}/items/${itemId}/archive`);
  return data;
}

export async function unarchiveKnowledgeItem(itemId) {
  const { data } = await apiClient.post(`${BASE}/items/${itemId}/unarchive`);
  return data;
}

export async function reindexKnowledgeVersion(itemId, versionId) {
  const { data } = await apiClient.post(
    `${BASE}/items/${itemId}/versions/${versionId}/reindex`
  );
  return data;
}

export async function searchKnowledge(body) {
  const { data } = await apiClient.post(`${BASE}/search`, body);
  return data;
}

export async function listIngestionJobs(limit = 50) {
  const { data } = await apiClient.get(`${BASE}/jobs`, { params: { limit } });
  return data;
}

/** Resolve id or source_key to { id, source_key, title } (KNOWLEDGE_READ). */
export async function resolveKnowledgeItem(payload) {
  const { data } = await apiClient.post(`${BASE}/items/resolve`, payload);
  return data;
}

export default {
  fetchKnowledgeConfig,
  listKnowledgeItems,
  getKnowledgeItem,
  createKnowledgeItem,
  prepareKnowledgeDocument,
  extractKnowledgeImportText,
  addKnowledgeVersion,
  publishKnowledgeVersion,
  archiveKnowledgeItem,
  unarchiveKnowledgeItem,
  reindexKnowledgeVersion,
  searchKnowledge,
  listIngestionJobs,
  resolveKnowledgeItem,
};
